import React from 'react';
export function Header() {
  const scrollToCallToAction = () => {
    const ctaSection = document.getElementById('call-to-action-section');
    if (ctaSection) {
      ctaSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className="w-full bg-gradient-to-r from-teal-50 to-blue-50 py-4 sm:py-4 border-b border-gray-200 sticky top-0 z-50" data-id="element-377">
      <div className="max-w-6xl mx-auto px-4 sm:px-14 lg:px-14 flex justify-between items-center gap-3 sm:gap-4" data-id="element-378">
        <div className="flex items-center gap-3 sm:gap-3 min-w-0 flex-1" data-id="element-379">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/autzkEYmrR1Ben8o7XHz63/Green_Organic_Health_and_Wellness_Blog_Logo_-_1_-_Edited.png" alt="American Blog of Ophthalmology Logo" className="h-10 w-10 sm:h-20 sm:w-20 md:h-12 md:w-12 object-contain flex-shrink-0" width="58" height="58" data-id="element-380" />
          <h1 className="text-base sm:text-lg md:text-x2 lg:text-2xl font-bold text-gray-900 leading-tight min-w-0" data-id="element-381">
            <span className="text-gray-900" data-id="element-382">American Blog Of </span>
            <span className="text-teal-600" data-id="element-383">Ophthalmology</span>
          </h1>
        </div>
        <div className="flex-shrink-0" data-id="element-384">
          <button onClick={scrollToCallToAction} className="bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white font-bold py-2.5 px-4 sm:py-2.5 sm:px-4 md:py-3 md:px-6 lg:px-8 rounded-full transition-all duration-300 shadow-md hover:shadow-lg transform hover:-translate-y-0.5 active:translate-y-0 border border-teal-400 cursor-pointer text-sm sm:text-sm md:text-base whitespace-nowrap pulse-animation" data-id="element-385">
            <span className="hidden sm:inline" data-id="element-386">Goodbye Dry Eyes</span>
            <span className="sm:hidden" data-id="element-387">Goodbye Dry Eyes</span>
          </button>
        </div>
      </div>
    </header>;
}